const APP_VERSION = "2.1.10"

export default {
  APP_VERSION: APP_VERSION,
  APP_CLINIPASS_VERSION: "1.0.6",
}   